import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import ProductTabs from "../../../Componants/Common/product tabs/ProductTabs";
import config from "../../../Componants/Common/config";
import {
  Autocomplete,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CommonButton from "../../../Componants/Common/Button";
import InputFileUpload from "../../../Componants/Common/Bulk Upload/InputFileUpload";
import Template from "../../../Componants/Common/Bulk Upload/Template";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import deleteIcon from "../../../Assests/deleteIcon.svg";
import ExportToExcel from "../../../Componants/Common/ExportToExcel";
import {
  createCategory,
  deleteCategory,
  exportSubCategory,
  fetchAllCategoryList,
  fetchBrandList,
  fetchCategoryList,
  fetchCategoryList2,
  updateCategory,
  updateCategoryStatus,
  fetchSubCategoryList,
  createSubCategory,
  updateSubCategory,
  exportCategory,
} from "../../../API Service/apiService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import Paginate from "../../../Componants/Common/Paginate";

const cells = ["S.No", "Brand", "Category", "Description", "Action"];
const categoryheader = [
  { label: "Brand", key: "brandName" },
  { label: "Category", key: "categoryName" },
  { label: "Description", key: "description" },
  { label: "Status", key: "active" },
];

const Manageproductcatgeory = () => {
  const [brandName, setBrandName] = useState("");
  const [description, setDescription] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [subCategoryName, setSubCategoryName] = useState(""); // For subcategory in create/edit
  const [loading, setLoading] = useState(false);
  const [editIndex, setEditIndex] = useState(false);
  const pageSize = config.pageSize;
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null); // For subcategory in create/edit
  const [totalRecords, setTotalRecords] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [dataSize, setDataSize] = useState(pageSize);
  const [tableData, setTableData] = useState([]); // Ensure initialized as empty array
  const [brandList, setBrandList] = useState([]);
  const [activeBrandList, setActiveBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]); // For all categories
  const [createCategoryList, setCreateCategoryList] = useState([]); // For create/edit form categories
  const [subCategoryList, setSubCategoryList] = useState([]); // For all subcategories
  const [brandError, setBrandError] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [subCategoryError, setSubCategoryError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  // Search states
  const [searchInputBrand, setSearchInputBrand] = useState("");
  const [searchInputCategory, setSearchInputCategory] = useState("");
  const [searchInputSubCategory, setSearchInputSubCategory] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [searchParams, setSearchParams] = useState({
    brandId: "",
    categoryName: "",
   
    page: 1,
    limit: 10,
  });

  const getBrandList = async () => {
    try {
      setLoading(true);
      const response = await fetchBrandList();
      setBrandList(response.data.brandList || []);
      const filteredActiveBrands = (response.data.brandList || []).filter(
        (brand) => brand.active === true
      );
      setActiveBrandList(filteredActiveBrands);
    } catch (error) {
      console.error("Error fetching brand list:", error);
      // Only show toast for user actions, not for dropdown data loading
      setBrandList([]);
      setActiveBrandList([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchAllCategoryList(params);
      if (response.data && response.data.categories) {
        setTableData(response.data.categories || []);
        setTotalRecords(response.data.totalCategories || 0);
      } else {
        setTableData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      // Show toast only for explicit user actions like search
      if (isSearching) {
        toast.error("Failed to fetch search results");
      }
      setTableData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoriesByBrand = async (brandId) => {
    try {
      setLoading(true);
      const response = await fetchCategoryList2(brandId, "", "", "");
      setCategoryList(response.data.categories || []);
    } catch (error) {
      console.error("Error fetching categories by brand:", error);
      // Don't show toast for dropdown data loading
      setCategoryList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBrandList();
  }, []);

  useEffect(() => {
    // Only fetch categories when page or limit changes, not when search parameters change
    if (!isSearching) {
      fetchCategories();
    }
  }, [page, limit]);

  const truncateText = (text, maxLength) => {
    // Safe check for undefined or null text
    if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  const handleCancel = () => {
    setBrandName("");
    setCategoryName("");
    setSubCategoryName("");
    setDescription("");
    setSelectedBrand(null);

    setEditIndex(false);
    setBrandError(false);
    setCategoryError(false);

    setDescriptionError(false);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setSearchParams((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = [];

    if (!selectedBrand || !selectedBrand._id) {
      setBrandError(true);
      errors.push("Brand is required");
      isValid = false;
    } else {
      setBrandError(false);
    }

    if (!categoryName.trim()) {
      setCategoryError(true);
      errors.push("Category is required");
      isValid = false;
    } else {
      setCategoryError(false);
    }

    if (!description.trim()) {
      setDescriptionError(true);
      errors.push("Description is required");
      isValid = false;
    } else {
      setDescriptionError(false);
    }

    if (!isValid) {
      return;
    }

    const requestData = {
      brandId: selectedBrand._id,
      categoryName: categoryName.trim(),
      description: description.trim(),
    };

    try {
      setLoading(true);
      let response;

      if (!editIndex) {
        response = await createCategory(requestData);
        toast.success("Category created successfully");
      } else {
        const dataToUpdate = {
          _id: editIndex,
          ...requestData,
        };
        response = await updateCategory(dataToUpdate);
        toast.success("Category updated successfully");
        setEditIndex(false);
      }

      // Refresh the data
      if (!isSearching) {
        await fetchCategories();
      } else {
        await handleSearch();
      }
      handleCancel();
    } catch (error) {
      console.error("Error saving/updating category:", error);
      toast.error(error.response?.data?.message || "Failed to save changes");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (row) => {
    setEditIndex(row._id);
    setSelectedBrand({ _id: row.brandId, brandName: row.brandName });
    setBrandName(row.brandName);
    setCategoryName(row.categoryName);
    setDescription(row.description);
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      const params = {
        search: searchParams.search,
        brandName: searchParams.brandName,
      };
      const response = await exportCategory(params);
      const blob = new Blob([response], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "categories.xlsx";
      document.body.appendChild(a);
      a.click();
      console.log(response);
    } catch (error) {
      console.log(`Error in export subcategory: ${error}`);
      toast.error("Failed to export subcategory");
    } finally {
      setLoading(false);
    }
  };

  const handleStatus = async (index, categoryId) => {
    if (!categoryId) {
      console.error("Invalid category ID");
      return;
    }

    try {
      setLoading(true);
      const response = await updateCategoryStatus({ _id: categoryId });

      if (response.status === "success") {
        toast.success("Status updated successfully");
        // Refresh the data
        if (!isSearching) {
          await fetchCategories();
        } else {
          await handleSearch();
        }
      } else {
        throw new Error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(error.response?.data?.message || "Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      setIsSearching(true);
      setPage(1);

      const searchBody = {
        brandId: searchInputBrand || "",
        categoryId: searchInputCategory || "",
        page: 1,
        limit: limit,
      };

      setSearchParams(searchBody);

      const response = await fetchCategoryList(
        searchBody.brandId,
        searchBody.categoryId,
        searchBody.page,
        searchBody.limit
      );

      if (response.data) {
        setTableData(response.data.categories || []);
        setTotalRecords(response.data.totalCategories || 0);
      } else {
        setTableData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error in search:", error);
      // Show toast for search since it's a user-initiated action
      toast.error(
        error.response?.data?.message || "Failed to search categories"
      );
      setTableData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchCancel = async () => {
    setSearchInputBrand("");
    setSearchInputCategory("");

    setSearchParams({
      brandId: "",
      categoryId: "",

      page: 1,
      limit: 10,
    });
    setFilteredCategories([]);

    setIsSearching(false);
    await fetchCategories();
  };

  const handleBrandSelection = async (event, newValue) => {
    const brandId = newValue?._id || "";
    setSearchInputBrand(brandId);
    setSearchParams((prev) => ({
      ...prev,
      brandId,
      categoryId: "",
      subCategoryName: "",
    }));
    setSearchInputCategory("");
    setSearchInputSubCategory("");
    setFilteredSubCategories([]);

    if (brandId) {
      try {
        setLoading(true);
        const response = await fetchCategoryList2(brandId, "", "", "");
        setFilteredCategories(response.data.categories || []);
      } catch (error) {
        console.error("Error fetching categories for brand:", error);
        toast.error("Failed to fetch categories for selected brand");
        setFilteredCategories([]);
      } finally {
        setLoading(false);
      }
    } else {
      setFilteredCategories([]);
    }
  };

  const handleCategorySelection = async (event, newValue) => {
    const categoryId = newValue?.categoryName || "";
    setSearchInputCategory(categoryId);
    setSearchParams((prev) => ({
      ...prev,
      categoryName: newValue.categoryName
    }));
    setSearchInputSubCategory("");
    setFilteredSubCategories([]);
  };

  const handleSubCategorySelection = (event, newValue) => {
    const subCategoryName = newValue?.subCategoryName || "";
    setSearchInputSubCategory(subCategoryName);
    setSearchParams((prev) => ({
      ...prev,
      subCategoryName,
    }));
  };

  // Handlers for create/edit form selections
  const handleCreateBrandSelection = async (event, newValue) => {
    setSelectedBrand(newValue || null);
    setBrandName(newValue?.brandName || "");
    setBrandError(false);
    setSelectedCategory(null);
    setCategoryName("");
    setSubCategoryName("");
    setSelectedSubCategory(null);

    if (newValue) {
      await fetchCategoriesByBrand(newValue._id);
    } else {
      setCreateCategoryList([]);
    }
  };

  const handleCreateCategorySelection = async (event, newValue) => {
    setSelectedCategory(newValue || null);
    setCategoryName(newValue?.categoryName || "");
    setCategoryError(false);
    setSubCategoryName("");
    setSelectedSubCategory(null);
  };

  const handleCreateSubCategorySelection = (event, newValue) => {
    setSelectedSubCategory(newValue || null);
    setSubCategoryName(newValue?.subCategoryName || "");
    setSubCategoryError(false);
  };

  const categoryDropdown1 = async (brandId) => {
    try {
      // const response = await
    } catch (error) {}
  };

  return (
    <Grid container>
      {loading && <Loader />}
      <Toaster position="top-center" reverseOrder={false} />
      <HeaderNavigation value={"Product > Category"} location={"/setting"} />
      {/* Create Category */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <ProductTabs selectedTab="two" />
        </Grid>
        <Grid container spacing={10}>
          <Grid item>
            {!editIndex && (
              <Autocomplete
                id="create-brand-select"
                options={activeBrandList}
                getOptionLabel={(option) => option.brandName || ""}
                value={selectedBrand || null}
                onChange={handleCreateBrandSelection}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Brand"
                    variant="standard"
                    style={{ width: "10rem" }}
                    error={brandError}
                    helperText={brandError ? "Brand is required." : ""}
                    required
                  />
                )}
              />
            )}
            {editIndex && (
              <Autocomplete
                id="edit-brand-select"
                options={activeBrandList}
                getOptionLabel={(option) => option.brandName || ""}
                value={selectedBrand || null}
                onChange={handleCreateBrandSelection}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Brand"
                    variant="standard"
                    style={{ width: "10rem" }}
                    error={brandError}
                    helperText={brandError ? "Brand is required." : ""}
                    required
                  />
                )}
              />
            )}
          </Grid>

          <Grid item>
            <TextField
              style={{ width: "10rem" }}
              id="Category"
              label="Category"
              variant="standard"
              value={categoryName}
              onChange={(e) => {
                setCategoryName(e.target.value);
                setCategoryError(false);
              }}
              error={categoryError}
              helperText={categoryError ? "Category is required." : ""}
              required
            />
          </Grid>

          <Grid item>
            <TextField
              style={{ width: "10rem" }}
              id="description"
              label="Description"
              variant="standard"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setDescriptionError(false);
              }}
              error={descriptionError}
              helperText={descriptionError ? "Description is required." : ""}
              required
            />
          </Grid>
        </Grid>
        <Grid container gap={2} spacing={5} sx={{ marginTop: "1rem" }}>
          <Grid item>
            <CommonButton
              name={editIndex === false ? "Save" : "Update"}
              handleOnClick={handleSave}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Cancel"} handleOnClick={handleCancel} />
          </Grid>
        </Grid>
      </Grid>

      {/* Bulk Upload */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid container>
          <Typography variant="h6">Bulk Upload</Typography>
        </Grid>
        <Grid container gap={10}>
          <Grid item>
            <InputFileUpload />
          </Grid>
          <Grid item>
            <CommonButton name={"Upload"} />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <Template label={"Download Template"} />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <Template label={"Download Reference Code"} />
          </Grid>
        </Grid>
      </Grid>

      {/* Category List */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          <Typography variant="h6">List View</Typography>
        </Grid>
        <Grid container gap={5}>
          <Grid item sx={{ minWidth: "200px" }}>
            <Autocomplete
              id="search-brand-select"
              options={brandList}
              getOptionLabel={(option) => option.brandName || ""}
              value={
                brandList.find((brand) => brand._id === searchInputBrand) ||
                null
              }
              onChange={handleBrandSelection}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand"
                  variant="standard"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item sx={{ minWidth: "200px" }}>
            <Autocomplete
              id="search-category-select"
              options={filteredCategories}
              getOptionLabel={(option) => option.categoryName || ""}
              value={
                filteredCategories.find(
                  (category) => category.categoryName === searchInputCategory
                ) || null
              }
              onChange={handleCategorySelection}
              disabled={!searchInputBrand}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  variant="standard"
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item>
            <CommonButton name="Search" handleOnClick={handleSearch} />
          </Grid>
          <Grid item>
            <CommonButton name="Cancel" handleOnClick={handleSearchCancel} />
          </Grid>
        </Grid>

        <Grid container>
          <Grid container justifyContent="flex-end">
            <ExportToExcel onClick={handleExport} />
          </Grid>

          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        textAlign:
                          index === cells.length - 1 ? "right" : "center",
                        paddingRight: index === cells.length - 1 ? "4rem" : "",
                      }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {!tableData || tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={cells.length} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {(page - 1) * dataSize + index + 1}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row?.brandName || "", 50)}
                      </TableCell>
                      <TableCell align="center">
                        {truncateText(row?.categoryName || "", 50)}
                      </TableCell>

                      <TableCell align="center">
                        {truncateText(row?.description || "", 50)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton
                          onClick={() => handleStatus(index, row._id)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={
                              (row?.active === false
                                ? inactiveIcon
                                : activeIcon) || inactiveIcon // Fallback in case active is undefined
                            }
                            alt="active"
                            height="20px"
                            width="20px"
                          />
                        </IconButton>

                        <IconButton
                          onClick={() => handleEdit(row)}
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            height="20px"
                            width="20px"
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <div
          className="pagination-container"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Paginate
            page={page}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            dataSize={dataSize}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Manageproductcatgeory;
